<template>
  <div class="attitudes-award-view">
    <SlideShowSection :items="slidesAwards" :loading="loadingSlidesAwards" />
    <AboutSection />
    <TopicsSection />
    <GalleriesSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import AboutSection from "../components/sections/premioatitudes/AboutSection.vue";
import TopicsSection from "../components/sections/premioatitudes/TopicsSection.vue";
import GalleriesSection from "../components/sections/premioatitudes/GalleriesSection.vue";

export default {
  data: () => ({
    loadingSlidesAwards: true,
    slidesAwards: [],
  }),
  created() {
    this.$rest("attitudes-award-slides")
      .get()
      .then((bufferedSlides) => {
        this.slidesAwards = bufferedSlides;
      })
      .then(() => (this.loadingSlidesAwards = false));
  },
  components: {
    SlideShowSection,
    AboutSection,
    TopicsSection,
    GalleriesSection,
  },
};
</script>

<style lang="scss" scoped></style>
